
"use client";

import { apiClient } from "@/config/api";

interface LogPayload {
    feature: string;
    input: any;
    output: any;
    sessionId: string;
}

// Helper function to safely stringify objects, handling circular references
const safeStringify = (obj: any): string => {
    const cache = new Set();
    return JSON.stringify(obj, (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.has(value)) {
                // Circular reference found, discard key
                return '[Circular]';
            }
            // Store value in our collection
            cache.add(value);
        }
        return value;
    });
};

export const logAiFeatureUsage = async (payload: LogPayload) => {
    try {
        const { input, output, ...rest } = payload;
        
        // Sanitize and prepare data for backend logging
        const logData = {
            ...rest,
            inputPayload: safeStringify(input),
            outputPayload: safeStringify(output),
            timestamp: new Date().toISOString(),
        };

        // Send to backend logging endpoint (if available)
        // For now, we'll just log to console and could extend this later
        
        // TODO: Add backend logging endpoint when available
        // await apiClient.post('/api/log-ai-usage', logData);

    } catch (error) {
        console.error("Failed to log AI feature usage:", error);
        // This is a background task, so we don't bother the user with a toast.
    }
};
